module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('finish.finished')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('menu.team_name')) + ": " + _vm._s(_vm.team.name)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('menu.score')) + ": " + _vm._s(_vm.team.score) + "\n                    ")]), _vm._v(" "), (_vm.event.comments && _vm.event.comments.outro) ? _c('p', [_vm._v(_vm._s(_vm.event.comments.outro))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-link text-danger",
    on: {
      "click": function($event) {
        _vm.exit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('common.exit')) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop fade in"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6109f8e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finish.vue
// module id = 371
// module chunks = 0